export default "__VITE_ASSET__V3e7W3YK__"